import React from "react"
import "./Banner.scss"

const Banner = () => {
  return (
    <div className="banner-items">
      {/* <a
        href="https://www.youtube.com/live/k7kz93V99RY"
        className="banner-item"
        target="_blank"
        rel="noreferrer"
        data-gtm-click="banner-getNotified"
      ></a> */}
      <a
        href="https://www.youtube.com/live/tqmxQ0eBVCQ"
        className="banner-item-archive-day1"
        target="_blank"
        rel="noreferrer"
        data-gtm-click="banner-archiveDay1"
      ></a>
      <a
        href="https://www.youtube.com/live/k7kz93V99RY"
        className="banner-item-archive-day2"
        target="_blank"
        rel="noreferrer"
        data-gtm-click="banner-archiveDay2"
      ></a>
      <a href="#official-merch" className="banner-item-red">
        <div className="event-specific-goods-text-box">
          <p className="event-specific-goods-text">
            Official
            <span className="sp-text-space"></span>
            <br className="pc-break" />
            Merchandise
          </p>
        </div>
      </a>
    </div>
  )
}

export default Banner
